import {
  LayoutDashboard, FolderKanban, FileSpreadsheet, ListChecks, CalendarDays,
  ShoppingCart, Warehouse, Settings, Users, CreditCard, FileText,
  CircleDollarSign, Building2, Package, Shield, Activity, Layers, UserCheck,
  Handshake, FileArchive, ShieldCheck, TrendingUp, Camera, HardHat, ClipboardCheck, BarChart3,
  FileQuestion, Gavel, ClipboardX, FileCheck, FileDown, ClipboardList,
} from "lucide-react";

export const GLOBAL_NAV = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, group: "Main" },
  { id: "projects", label: "Projects", icon: FolderKanban, group: "Main" },
  { id: "tender", label: "Tender & Bids", icon: Gavel, group: "Main" },
];

export const PROJECT_NAV = [
  { id: "controlcenter", label: "PM Command Center", icon: Activity },
  { id: "supervisorcc", label: "Supervisor Command Center", icon: HardHat },
  { id: "daily", label: "Daily Site Report", icon: CalendarDays },
  { id: "tasks", label: "Work Programme", icon: ListChecks },
  { id: "variations", label: "Variations", icon: Layers },
  { id: "warehouse", label: "Warehouse", icon: Warehouse },
  { id: "equipment", label: "Equipment & Tools", icon: Settings },
  { id: "subcontractors", label: "Subcontractors", icon: Handshake },
  { id: "documents", label: "Documents", icon: FileArchive },
  { id: "permitsqc", label: "Permits & QC", icon: ClipboardCheck },
  { id: "hse", label: "HSE & Quality", icon: ShieldCheck },
  { id: "sitephotos", label: "Site Photos", icon: Camera },
  { id: "projectteam", label: "Project Team", icon: Users },
];

export const FINANCE_NAV = [
  { id: "procurement", label: "Procurement", icon: ShoppingCart },
  { id: "budgetcost", label: "BOQ & Cost Control", icon: FileSpreadsheet },
  { id: "evm", label: "EVM Dashboard", icon: BarChart3 },
  { id: "cashflow", label: "Cash Flow / S-Curve", icon: TrendingUp },
  { id: "ipc", label: "Progress Claims (IPC)", icon: FileCheck },
  { id: "payments", label: "Payments", icon: CreditCard },
  { id: "vendorfinance", label: "Vendor Finance", icon: FileText },
  { id: "clientfinance", label: "Client Finance", icon: CircleDollarSign },
  { id: "employeefinance", label: "Employee Finance", icon: Users },
  { id: "accounts", label: "Company Accounts", icon: CreditCard },
];

export const HR_NAV = [
  { id: "hr", label: "HR / People", icon: UserCheck },
];

export const HQ_NAV = [
  { id: "headoffice", label: "Head Office", icon: Building2 },
  { id: "tenders", label: "Tenders", icon: Gavel },
];

export const BOTTOM_NAV = [
  { id: "approvals", label: "Approvals", icon: ClipboardCheck, group: "Setup" },
  { id: "registers", label: "Registers", icon: Package, group: "Setup" },
  { id: "reports", label: "Reports & Export", icon: FileDown, group: "Setup" },
  { id: "admin", label: "Admin & Settings", icon: Shield, group: "Setup" },
];

export const NAV_ITEMS = [...GLOBAL_NAV, ...PROJECT_NAV.map(n => ({ ...n, group: "Project" })), ...FINANCE_NAV.map(n => ({ ...n, group: "Finance" })), ...HR_NAV.map(n => ({ ...n, group: "HR" })), ...HQ_NAV.map(n => ({ ...n, group: "HQ" })), ...BOTTOM_NAV];
